import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const wixRouterSitemapEntryRuntime = createHostModule({
    changeFrequency: ({ channel }) => function changeFrequency(...args) {
        return channel.invoke({
            namespace: 'site',
            method: 'wixRouterSitemapEntry.changeFrequency',
            args,
        });
    },
    lastModified: ({ channel }) => function lastModified(...args) {
        return channel.invoke({
            namespace: 'site',
            method: 'wixRouterSitemapEntry.lastModified',
            args,
        });
    },
    pageName: ({ channel }) => function pageName(...args) {
        return channel.invoke({
            namespace: 'site',
            method: 'wixRouterSitemapEntry.pageName',
            args,
        });
    },
    priority: ({ channel }) => function priority(...args) {
        return channel.invoke({
            namespace: 'site',
            method: 'wixRouterSitemapEntry.priority',
            args,
        });
    },
    title: ({ channel }) => function title(...args) {
        return channel.invoke({
            namespace: 'site',
            method: 'wixRouterSitemapEntry.title',
            args,
        });
    },
    url: ({ channel }) => function url(...args) {
        return channel.invoke({
            namespace: 'site',
            method: 'wixRouterSitemapEntry.url',
            args,
        });
    },
});
//# sourceMappingURL=wixRouterSitemapEntry.runtime.js.map